import { LinkOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { noticeRecall, queryNoticeList } from '@api/announcement';
import { NoticeListFilterInterface } from '@api/announcement/type';
import ZeissButton from '@components/button';
import ZeissInput from '@components/input';
import NoticeRevertModal from '@components/revertModal';
import ZeissTable from '@components/table';
import ZeissTabs from '@components/tabs';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_PAGINATION,
  ROLE_KEYS_MAP
} from '@constants';
import { PaginationInterface } from '@constants/types';
import { DicListHook } from '@hooks/useDicListHook';
import { UseSystemCity } from '@hooks/useSystemCity';
import { userInfo } from '@store';
import { getCityItem, getDomianRelativeUrl } from '@utils/tool';
import { AddSubjectMatter } from '@views/pages/AnnouncementList/Announcement/AddSubjectMatter';
import {
  CreateAnnouncement,
  dealerSectorArr
} from '@views/pages/AnnouncementList/Announcement/CreateAnnouncement';
import type { TablePaginationConfig, TableProps, TabsProps } from 'antd';
import { Badge, Form, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { useEffect, useMemo, useRef, useState } from 'react';
// import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import AToolBar from './AToolBar';
import { initialSubjectMatterItemValues } from './Announcement/CreateAnnouncement';
import AnnouncementSearchForm from './Form/announcementSearchForm';
import {
  announcementTabStatusMap,
  comfirmTagClassMap,
  CONFIRM_RESULT_STATUS_MAP,
  NOTICE_STATUS,
  tagClassMap,
  TIMELINE_STATUS,
  use_ALL_ANNOUNCEMENTS_COLUMNS
} from './announcement';
import { ShowSalesModalStatusEnum } from './tool';
import './index.scss';

const AnnouncementList = () => {
  const [open, setOpen] = useState(false); //新建公告弹框
  const [subjectMatterOpen, setSubjectMatterOpen] = useState(false); //添加标的物弹框
  const [pagination, setPagination] =
    useState<PaginationInterface>(DEFAULT_PAGINATION);
  const [tabStatus, setTabStatus] = useState<any>('');
  const [dataSource, setDataSource] = useState<any>([]);
  const [tabCounts, setTabCount] = useState<any>({});
  const [revertModalShow, setRevertModalShow] = useState<boolean>(false);
  const [curTableItem, setCurTableItem] = useState<any>({});
  const inputFilterRef = useRef<any>(null);
  const [form] = Form.useForm();
  // const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const searchCriteriaFromRef = useRef<any>(null);
  const dicList = DicListHook();
  const { productLine } = dicList;
  const { data: systemCity, provinceData: filterFormSystemCity } =
    UseSystemCity();
  const [userInfos] = useRecoilState(userInfo);
  const ALL_ANNOUNCEMENTS_COLUMNS = use_ALL_ANNOUNCEMENTS_COLUMNS();

  const getList = async (
    pageInfo: PaginationInterface = pagination,
    filter: any = { noticeStatus: tabStatus }
  ) => {
    const params = {
      ...filter,
      ...pageInfo
    };
    const res = await queryNoticeList(params);
    const { page, ...tabCountsData } = res ?? {};

    setDataSource(page?.records);
    setTabStatus(params.noticeStatus);
    setPagination({
      ...pagination,
      pageNumber: page.current,
      pageSize: page.size,
      total: page.total
    });
    setTabCount(tabCountsData);
  };

  useEffect(() => {
    getList();
  }, []);

  const handleTableChange = async (pagination: any) => {
    const formValue = await getCurrentFilterParams();
    getList({
      ...formValue,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize
    });
  };

  const pageProps: TablePaginationConfig = {
    current: pagination.pageNumber,
    pageSize: pagination.pageSize,
    total: pagination.total ?? 10
  };

  const onRevertConfirm = async () => {
    const params = {
      code: curTableItem?.noticeCode,
      operatorUserId: userInfos.userId,
      operatorUserName: userInfos.realName
    };
    await noticeRecall(params);
    handleInputSubmit();
    setRevertModalShow(false);
  };

  const onRevertClick = (record: any) => {
    setCurTableItem(record);
    setRevertModalShow(true);
  };

  // isShowSalesModal 1 显示 2 不显示
  const goToDetailPage = (
    record: any,
    isShowSalesModal: ShowSalesModalStatusEnum = ShowSalesModalStatusEnum.HIDE
  ) => {
    window.open(
      `${getDomianRelativeUrl()}/announcement/announcementDetail?noticeId=` +
        record?.noticeCode +
        `&isShowSalesModal=${isShowSalesModal}`
    );
    // navigate(`/announcement/announcementDetail?noticeId=` + record?.noticeCode);
  };

  const isShowRevert = useMemo(() => {
    return (
      tabStatus === announcementTabStatusMap.Confirmed &&
      userInfos.roleKeys === ROLE_KEYS_MAP.sales
    );
  }, [tabStatus, userInfos]);

  const columnsList: ColumnsType = [
    ...ALL_ANNOUNCEMENTS_COLUMNS.map((v) => {
      const { key } = v;
      if (key === 'noticeName') {
        v.render = (value, record) => {
          return (
            <div
              className="list_noticeName"
              onClick={() => goToDetailPage(record)}
            >
              <LinkOutlined />
              <span className="list_noticeName_text">{value}</span>
            </div>
          );
        };
      }
      return v;
    }),
    {
      title: '状态',
      dataIndex: 'noticeStatusValue',
      key: 'noticeStatusValue',
      width: 150,
      fixed: 'right',
      render: (val: any, record: any) => {
        const { noticeStatus, confirmResultStatus, confirmResultStatusValue } =
          record;
        if (noticeStatus !== TIMELINE_STATUS.Confirmed) {
          return (
            <Tag className={`tag_base ${tagClassMap[noticeStatus]}`}>{val}</Tag>
          );
        }
        return (
          <Tag
            className={`tag_base ${comfirmTagClassMap[confirmResultStatus]}`}
          >
            {confirmResultStatus === CONFIRM_RESULT_STATUS_MAP.NOT
              ? `${val}-${confirmResultStatusValue}`
              : confirmResultStatusValue}
          </Tag>
        );
      }
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: isShowRevert ? 130 : 80,
      fixed: 'right' as const,
      render: (val: any, record: any) => {
        // const { noticeStatus } = record;
        // 完成确认tab
        return (
          <div>
            <ZeissButton
              type="link"
              onClick={() => goToDetailPage(record)}
              style={{ paddingLeft: 0 }}
            >
              去处理
            </ZeissButton>
            {isShowRevert && (
              <ZeissButton
                style={{ paddingLeft: 0, paddingRight: 0 }}
                type="link"
                onClick={() => onRevertClick(record)}
              >
                撤回
              </ZeissButton>
            )}
          </div>
        );
      }
    },
    ...(tabStatus !== announcementTabStatusMap.Confirmed &&
    tabStatus !== announcementTabStatusMap.Uncorrelated &&
    tabStatus !== announcementTabStatusMap.Repetition
      ? [
          {
            title: '是否逾期',
            dataIndex: 'overdue',
            key: 'overdue',
            fixed: 'right' as const,
            width: 80,
            render: (_: any, record: any) => {
              //  是否逾期 1逾期 0没有 全部列表中完成确认/不相关/重复的公告不显示逾期状态
              const { overdue } = record;
              return (
                <div>
                  {record.noticeStatus !== NOTICE_STATUS.Confirmed &&
                  record.noticeStatus !== NOTICE_STATUS.Uncorrelated &&
                  record.noticeStatus !== NOTICE_STATUS.Repetition ? (
                    overdue === 1 ? (
                      <div className="overdue_wrap">
                        <span className="overdue">是</span>
                      </div>
                    ) : (
                      '否'
                    )
                  ) : null}
                </div>
              );
            }
          }
        ]
      : [])
  ];

  const onSelectChange = (
    newSelectedRowKeys: React.Key[]
    // selectedRows: any[]
  ): void => {
    setSelectedRowKeys(newSelectedRowKeys);
    // setSelectedIds(selectedRows.map((t) => t.id))
  };

  const rowSelection =
    userInfos.roleKeys !== ROLE_KEYS_MAP.sales &&
    userInfos.roleKeys !== ROLE_KEYS_MAP.dealer
      ? {
          selectedRowKeys,
          onChange: onSelectChange
        }
      : undefined;

  const tableProps: TableProps<any> = {
    columns: columnsList,
    dataSource,
    pagination: pageProps,
    rowKey: 'noticeCode',
    // size: 'small',
    onChange: handleTableChange,
    bordered: false,
    scroll: {
      x: 3600
    },
    rowSelection
  };

  const itemsBase: TabsProps['items'] = [
    {
      key: '',
      label: '全部公告'
    },
    {
      key: announcementTabStatusMap.TobeHandledByAdmin,
      label: '待Admin处理'
    },
    {
      key: announcementTabStatusMap.TobeHandledBySector,
      label: (
        <div className="pc-ann-layout">
          待Sector处理
          <Badge count={tabCounts.countStaySector} offset={[5, 0]}></Badge>
        </div>
      )
    },
    {
      key: announcementTabStatusMap.TobeConfirmedBySales,
      label: (
        <div className="pc-ann-layout">
          待销售确认
          <Badge count={tabCounts.countStaySales} offset={[5, 0]}></Badge>
        </div>
      )
    },
    {
      key: announcementTabStatusMap.TobeConfirmedByDealer,
      label: (
        <div className="pc-ann-layout">
          待经销商确认
          <Badge count={tabCounts.countStayDealer} offset={[5, 0]}></Badge>
        </div>
      )
    },
    {
      key: announcementTabStatusMap.Confirmed,
      label: '完成确认'
    },
    {
      key: announcementTabStatusMap.Uncorrelated,
      label: '不相关'
    },
    {
      key: announcementTabStatusMap.Repetition,
      label: '重复'
    }
  ];

  // sales 可见tab
  const salesTabsKeys = [
    '',
    announcementTabStatusMap.TobeConfirmedBySales,
    announcementTabStatusMap.Confirmed,
    announcementTabStatusMap.TobeConfirmedByDealer
  ];
  // sector 不可见tab
  const sectorNotShowKeys = [announcementTabStatusMap.TobeConfirmedByDealer];
  // Dealer 可见tab
  const dealerShowKeys = [
    '',
    announcementTabStatusMap.TobeConfirmedByDealer,
    announcementTabStatusMap.Confirmed,
    announcementTabStatusMap.Uncorrelated,
    announcementTabStatusMap.Repetition
  ];
  const items = useMemo(() => {
    if (userInfos.roleKeys === ROLE_KEYS_MAP.sales) {
      const sectorIds = userInfos.userTypesId || '';
      const firstSectorId = sectorIds.split(',')[0];
      const isV2 = dealerSectorArr.includes(firstSectorId);
      const newTabKey = isV2
        ? salesTabsKeys.concat([
            announcementTabStatusMap.Uncorrelated,
            announcementTabStatusMap.Repetition
          ])
        : salesTabsKeys;
      return itemsBase.filter((item) => newTabKey.includes(item.key));
    } else if (userInfos.roleKeys === ROLE_KEYS_MAP.sector) {
      return itemsBase.filter((item) => !sectorNotShowKeys.includes(item.key));
    } else if (userInfos.roleKeys === ROLE_KEYS_MAP.dealer) {
      return itemsBase.filter((item) => dealerShowKeys.includes(item.key));
    } else {
      return itemsBase;
    }
  }, [userInfos?.roleKeys, tabCounts]);

  const onTabsChange = async (key: string) => {
    const formValue = await getCurrentFilterParams();
    getList(pagination, { ...formValue, noticeStatus: key });
    setSelectedRowKeys([]);
  };

  const getCurrentFilterParams = async () => {
    const formValue = await getFormValue();

    const keyword = inputFilterRef.current?.input?.value || '';
    return {
      ...formValue,
      noticeStatus: tabStatus,
      keyword
    };
  };

  const getFormValue = async () => {
    const val = await searchCriteriaFromRef.current?.submitClick();

    const {
      provinceAndCity,
      publishTime,
      openTime,
      noticeProductLineKey,
      ...rest
    } = val;
    const noticeProductLineItem = productLine.find(
      (item: any) => item.dictKey === noticeProductLineKey
    );
    const obj: NoticeListFilterInterface = {
      ...rest,
      noticeProductLineKey,
      noticeProductLineName: noticeProductLineItem?.dictValue || ''
    };
    if (publishTime) {
      obj.publishTimeStart = dayjs(publishTime[0]).format(DEFAULT_DATE_FORMAT);
      obj.publishTimeEnd = dayjs(publishTime[1]).format(DEFAULT_DATE_FORMAT);
    }
    if (openTime) {
      obj.openTimeStart = dayjs(openTime[0]).format(DEFAULT_DATE_FORMAT);
      obj.openTimeEnd = dayjs(openTime[1]).format(DEFAULT_DATE_FORMAT);
    }
    if (provinceAndCity) {
      const provinceCodeList: any = [];
      provinceAndCity?.map((v: string[]) => {
        const provinceCode = getCityItem(v)?.code;
        provinceCodeList.push(provinceCode);
      });
      obj.provinceCodes = provinceCodeList;
    }

    return obj;
  };

  const handleInputSubmit = async () => {
    const val = inputFilterRef.current?.input?.value || '';
    const formValue = await getCurrentFilterParams();

    getList(pagination, {
      ...formValue,
      keyword: val
    });
  };

  //新建公告
  const handleCreateAnnouncement = () => {
    setOpen(true);
    form.setFieldValue('subjectMatter', [initialSubjectMatterItemValues]);
  };

  // 新建标的物
  const confirmAddSubjectMatterCallback = (data: any) => {
    const curData = form.getFieldsValue();
    form.setFieldsValue({
      subjectMatter: [...curData.subjectMatter, data]
    });
  };

  //新建公告
  const confirmAddNoticeCallback = async (data: any) => {
    const filterParams = await getCurrentFilterParams();
    getList(pagination, {
      ...filterParams
    });

    //跳转到详情页
    if (data?.noticeCode) {
      goToDetailPage(data, ShowSalesModalStatusEnum.SHOW);
    }
  };

  return (
    <div className="announcement_wrap">
      <ZeissTabs
        defaultActiveKey={''}
        items={items}
        activeKey={tabStatus}
        onChange={onTabsChange}
        tabBarExtraContent={
          <div>
            <ZeissInput
              placeholder="信息标题/项目名称/客户单位/标的物/中标商/标的物品牌"
              allowClear
              style={{ width: 380 }}
              onPressEnter={handleInputSubmit}
              ref={inputFilterRef}
              // suffix={<SearchOutlined onClick={handleInputSubmit} />}
            />
            <ZeissButton
              type="primary"
              style={{ margin: '0 10px' }}
              icon={<SearchOutlined />}
              onClick={handleInputSubmit}
            />
            {userInfos.roleKeys !== ROLE_KEYS_MAP.dealer && (
              <ZeissButton
                type="primary"
                onClick={handleCreateAnnouncement}
                icon={<PlusOutlined />}
              >
                新建公告
              </ZeissButton>
            )}
          </div>
        }
      />
      <AnnouncementSearchForm
        ref={searchCriteriaFromRef}
        tabKey={tabStatus}
        dicList={dicList}
        systemCity={filterFormSystemCity}
        onFieldsChange={handleInputSubmit}
      />
      {userInfos.roleKeys !== ROLE_KEYS_MAP.sales &&
        userInfos.roleKeys !== ROLE_KEYS_MAP.dealer && (
          <AToolBar
            getList={handleInputSubmit}
            noticeCodeList={selectedRowKeys}
          ></AToolBar>
        )}
      <ZeissTable {...tableProps} className="announcement_table_wrap" />

      <CreateAnnouncement
        open={open}
        setOpen={setOpen}
        setSubjectMatterOpen={setSubjectMatterOpen}
        dicList={dicList}
        systemCity={systemCity}
        handleOk={confirmAddNoticeCallback}
        subjectMatterForm={form}
      />
      <AddSubjectMatter
        open={subjectMatterOpen}
        setOpen={setSubjectMatterOpen}
        dicList={dicList}
        systemCity={systemCity}
        handleOk={confirmAddSubjectMatterCallback}
      />
      <NoticeRevertModal
        title="请确认是否撤回该公告?"
        open={revertModalShow}
        onCancel={() => setRevertModalShow(false)}
        onConfirm={onRevertConfirm}
      />
    </div>
  );
};
export default AnnouncementList;
